<template>
    <div>
      <header id="stzHeader" class="TheHeader">
        <b-container fluid>
          <b-row class="no-gutters">
            <b-col cols="2" md="4">
              <b-img src="../../static/svg/stzLogo.svg" fluid id="stzLogo" class="stzLogo" />
            </b-col>
            <b-col cols="10" md="8">
              <div id="stzHamburger" class="hamburger hamburgerAnimation">
                <span class="hamburger-box">
                  <span class="hamburger-inner"></span>
                </span>
              </div>
              <a href="/" id="headerLink"><b-img src="../../static/img/gbLogo@2x.png" fluid id="stzHeaderTitleArt" class="theLogo titleArt" /></a>
            </b-col>
          </b-row>
        </b-container>
      </header>

      <nav id="stzNavMenu" class="stzNavMenu">
          <a href="/#page5" class="navLink">Synopsis</a>
          <a href="/characters" class="navLink navAni">Characters</a>
           <a href="/production" class="navLink">Production Bios</a>
          <a href="/trailer" class="navLink">Season Two<br>Trailer</a>
          <a href="https://screeners.com/" target="_blank" class="navLink">Episodes</a>
         <a href="/photos"  class="navLink navAni2">Photos</a>
          <a href="/downloads" class="navLink">Downloadable<br>Press Materials</a>
           <a href="/contact" class="navLink">Press Contacts</a>
      </nav>

    </div>
</template>

<script>
  export default {
    name: 'TheHeader',
    mounted: function () {
      // Look for .hamburger
      var hamburger = document.querySelector('.hamburger')
      var headerRoute = document.querySelector('#headerLink')

      // Adjust menu and hamburger when clicking on the header title art.
      headerRoute.addEventListener('click', function () {
        if (document.getElementById('stzHamburger').classList.contains('is-active')) {
          document.getElementById('stzNavMenu').classList.remove('stzNavMenu-Open')
          document.getElementById('stzNavMenu').classList.add('stzNavMenu-Close')
          document.getElementById('stzHamburger').classList.remove('is-active')
          document.getElementById('stzHeaderTitleArt').classList.remove('titleArt-Hidden')
          document.getElementById('stzHeaderTitleArt').classList.add('logo')
        }
      })

      // Hamburger & Menu
      hamburger.addEventListener('click', function () {
        // Toggle class "is-active"
        hamburger.classList.toggle('is-active')
        // Do something else, like open/close menu
        if (document.getElementById('stzHamburger').classList.contains('is-active')) {
          document.getElementById('stzNavMenu').classList.add('stzNavMenu-Open')
          document.getElementById('stzNavMenu').classList.remove('stzNavMenu-Close')
          document.getElementById('stzHeaderTitleArt').classList.remove('titleArt-Hidden')
          document.getElementById('stzHeaderTitleArt').classList.add('logo')
        } else {
          document.getElementById('stzNavMenu').classList.remove('stzNavMenu-Open')
          document.getElementById('stzNavMenu').classList.add('stzNavMenu-Close')
          document.getElementById('stzHeaderTitleArt').classList.remove('logo')
          document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
        }
      })

      // Navigation items.
      var navLink = document.getElementsByClassName('navLink')
      var i
      // Navigation Items - Click Through
      for (i = 0; i < navLink.length; i++) {
        navLink[i].addEventListener('click', function () {
          // Close the menu after a selection
          document.getElementById('stzNavMenu').classList.remove('stzNavMenu-Open')
          document.getElementById('stzNavMenu').classList.add('stzNavMenu-Close')
          hamburger.classList.toggle('is-active')
        })
      }
      var headerLink = document.getElementById('headerLink')
      headerLink.addEventListener('click', function () {
        document.getElementById('stzHeaderTitleArt').classList.remove('logo')
        document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
      })
    }
  }
</script>

<style lang="scss" >



</style>


// WEBPACK FOOTER //
// src/components/TheHeader.vue